import { FetchHelper } from "shared-ts-utils-fetch";
import { CustomerEnvironmentName } from "firefly-shared-ts-customer-environment";
import { OrganizationDto } from "./Organization";
import { DependentImpl } from "shared-ts-ui-react";

export class OrganizationDao extends DependentImpl {
  private readonly fetchHelper: FetchHelper;

  constructor(args: { accessToken: string }) {
    super(args.accessToken);
    this.fetchHelper = new FetchHelper({
      basePath: "/api/organization/",
    }).authorizationBearer(args.accessToken);
  }

  async get(
    customerEnvironment: CustomerEnvironmentName
  ): Promise<OrganizationDto> {
    return this.fetchHelper
      .get("get")
      .setHeader("Firefly-Environment", customerEnvironment)
      .fetchAsJson();
  }
}
